import { Children, cloneElement, isValidElement } from 'react';

import { VFlex } from '../VFlex';
import { joinCn } from '../util';
import { VTabTrigger } from './VTabTrigger';
import { useVTab } from './hook';
import type { VTabContainerProps, VTabTriggerProps } from './type';

export const VTabTriggerContainer = ({
  children,
  className,
  fluid,
}: VTabContainerProps) => {
  const { twStyle } = useVTab();

  // NOTE: 의도적으로 depth1만 검사함 VTab위에 div로 스타일링할 경우 영향을 주지 않도록 함
  const clonedChildren = Children.map(children, child => {
    if (isValidElement<VTabTriggerProps>(child) && child.type === VTabTrigger) {
      return cloneElement<VTabTriggerProps>(child, {
        ...child.props,
        className: joinCn(
          {
            'flex-1': fluid,
          },
          child.props.className,
        ),
      });
    }
    return child;
  });

  return (
    <VFlex
      aria-label="v-tab-trigger-container"
      className={joinCn(twStyle.tabList, className)}
      role="menu"
      gap={0.125}
      items="center"
    >
      {clonedChildren}
    </VFlex>
  );
};

VTabTriggerContainer.displayName = 'VTabTriggerContainer';
